import * as React from 'react'
import * as PropTypes from 'prop-types'

import {
  ZingPointsBannerWrapper,
  ZingPointsBannerContainer,
  ContentWrapper,
  ZingBannerTitle,
  ZingBannerSubtitle,
  ButtonsContainer,
  StyledLinkButton,
} from './ZingPointsBanner.style'

const ZingPointsBanner = ({ accessToken, joinNowCallback, loginCallback }) => {
  // ST-8064 Remove Important Advisory
  if (accessToken) return null

  return (
    <ZingPointsBannerWrapper>
      <ZingPointsBannerContainer>
        <ContentWrapper>
          <ZingBannerTitle>Are you ready to Zing it?</ZingBannerTitle>
          <ZingBannerSubtitle>
            Find your favorite shops and restaurants, get exclusive deals and
            discounts, and join exciting promos and events!
          </ZingBannerSubtitle>
        </ContentWrapper>
        <ButtonsContainer>
          <StyledLinkButton
            to="/register"
            onClick={joinNowCallback}
            variant="primary"
          >
            Sign-up now
          </StyledLinkButton>
          <StyledLinkButton to="/login" onClick={loginCallback}>
            Login
          </StyledLinkButton>
        </ButtonsContainer>
      </ZingPointsBannerContainer>
    </ZingPointsBannerWrapper>
  )
}

ZingPointsBanner.defaultProps = {
  accessToken: null,
  joinNowCallback: () => {},
  loginCallback: () => {},
}

ZingPointsBanner.propTypes = {
  accessToken: PropTypes.string,
  joinNowCallback: PropTypes.func,
  loginCallback: PropTypes.func,
}

export default ZingPointsBanner
